/**
 * @function personalAccountAvatar the url to retrieve the avatar of the user, can be used in src of image components
 * @param {string} userId - the id of the user
 * @returns {Promise} Promise object represents
 */
export const personalAccountAvatar = (userId, timestamp) => {
  return `${process.env.REACT_APP_BACKEND_URL}/personal_account/avatar/${userId}?updated_at=${timestamp ?? Date.now()}`
}
